<div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>

    <p *ngIf="showText" class="black-text"> {{ 'pages.viewer.loading' | translate }} </p>
    
</div>